import React  from "react";
import {  injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import { getJobStatus,updateJobrStatus,getMenus} from "../../crud/auth.crud";

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
  formControl: {
     // margin: theme.spacing(1),
      minWidth: 120,
    },
};





class EditJobrStatus extends React.Component {
  state = {
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    jobRequest:null,
   mStatus:[],
   permission:[],

   }

constructor(props)
{
  super(props);
 
    this.state = {
      menu: false,
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      loading:false,
      statusColor:'alert-success',
      mStatus:[],
      jobRequest:null,
      permission:[],
    };
  
}
  
  
 
  async componentDidMount()
  {
    
   

  if(this.props.jobRequest!=null)
  {
    this.setState({jobRequest:this.props.jobRequest});
  }
 
     getJobStatus().then(response => response.data)
    .then((data) => {
      this.setState({ mStatus: data })
     // console.log(data);
     });

     getMenus().then(response => response.data)
         .then((data) => {
           
           if(data[0] != null && data[0].permissions !=null)
                     {
                      
                       console.log(data[0].permissions);
                       let perms="";
                       data[0].permissions.map((per) =>(
                         perms = perms + "," + per
                         ))
                       console.log(perms);
                        this.setState({ permission: perms })
     
                     }
          })
   
  }





  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;

     

    return (
      <>
          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}

          {this.state.jobRequest != null &&

          <Formik
                  initialValues={{
                 
                    status: this.state.jobRequest.jobStatusId,
                 
                    
                  }}
                  validate={values => {
                    const errors = {};

                    if (!values.status) {
                      errors.status = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting }) => {

                   this.setState({loading:true});
                   let schedule = {
                     
                      jobStatusKey: values.status,
                    

                   };
                    updateJobrStatus(this.state.jobRequest.id,values.status)
                      .then(resp => {
                        //props.register(accessToken);
                       
                        this.setState({status:true,
                        statusMessage:'Job Status has been updated successfully',
                        alertType:'alert-success',loading:false});
                        window.scrollTo(0,0);
                        let jobr = this.state.jobRequest;
                        jobr.jobStatusId = values.status;
                        this.props.onUpdate(jobr);
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
                      
          
     
          <div className="kt-section">
            <div className="kt-section__content">
            

         
              <div className="row">
                <TextField
                              labelId="status-label"
                              id="status"
                              margin="normal"
                              name="status"
                              value={values.status}
                              onChange={handleChange}
                              className="kt-width-full"
                              label="Select Status"
                              style={{'width':'100%'}}
                            select>
                              
                             
                              {this.state.mStatus.map((status) =>(
                               
                               (this.state.permission.includes("ALLOWEDJOBSTATUS:"+status.jobStatusId) || status.jobStatusId === values.status)&& <MenuItem key={status.jobStatusId} value={status.jobStatusId}>{status.statusDescription}</MenuItem>
                                 
                                 
                                
                              ))}
                            </TextField>
              </div>
            
    

              
        </div>
        </div>
       
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update
                        </button>
                      </div>
              

        </form>
            )}
            </Formik>
          
      }

       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditJobrStatus));

